export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/short_video_ads.4684144.svg";